import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';
import { Container } from '../../../components/container';

export const HomeSkeleton = () => (
  <Container>
    <Box sx={{ mb: 4, display: 'flex', alignItems: 'center' }}>
      <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
      <Skeleton variant="text" width={120} height={40} />
    </Box>

    <Box sx={{ mb: 4 }}>
      <Skeleton variant="text" width={300} height={48} sx={{ mb: 1 }} />
    </Box>

    <Grid container spacing={3}>
      {[0, 1, 2, 3].map((index) => (
        <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              transition: 'all 0.3s ease',
            }}
          >
            <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width={100} height={48} />
                </Box>
                <Skeleton variant="circular" width={56} height={56} />
              </Box>
              <Box sx={{ mt: 'auto' }}>
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
);
